import { ref } from 'vue';

/**
 * Composable to drive master-card swatches via reactive state,
 * rather than manual DOM fiddling.
 *
 * @returns {{
 *   cardRefs: import('vue').Ref<Record<string, {
 *     selectedHandle: string,
 *     selectedUrl: string,
 *     selectedColorway: string,
 *     selectedPrice: string,
 *     selectedCompareAtPrice: string,
 *     selectedImage: object
 *   }>>,
 *   setActiveColorway: (cardId: string, evt: Event) => void
 * }}
 */
export function useMasterProductCard() {
  const cardRefs = ref({});

  function setActiveColorway(cardId, evt) {
    const input = /** @type {HTMLInputElement} */ (evt.target);
    const saleParams = input.dataset.productSaleParams;
    cardRefs.value[cardId] = {
      selectedColorway: input.dataset.productColorway,
      selectedCompareAtPrice: input.dataset.productCompareAtPrice,
      selectedHandle: input.dataset.productHandle,
      selectedImage: JSON.parse(input.dataset.productImage),
      selectedIsOnSale: JSON.parse(input.dataset.productIsOnSale),
      selectedPrice: input.dataset.productPrice,
      selectedUrl: `${input.dataset.productUrl}${saleParams}`,
    };
  }

  return { cardRefs, setActiveColorway };
}
